import { Flex, SimpleGrid } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import Layout from "components/Layout";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { api } from "services/api";

const Vat = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();
  // const [activePage, setActivePage] = useState(1);
  // const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const [settingvalue, setSettingvalue] = useState("");

  const onSave = () => {
    setIsLoading(true);
    api
      .updateSetting({ settingid: "1", settingvalue: settingvalue })
      .then((res) => {
        setIsLoading(false);
        console.log(res);

        if (res?.status === 200) {
          toaster.create({
            title: res?.data?.message,
            type: "success",
          });
        } else {
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  useEffect(() => {
    setIsLoading(true);

    api.getVat().then((res) => {
      console.log(res);
      setIsLoading(false);

      if (res?.status === 200) {
        if (res?.data?.settingtype === "VAT") {
          setSettingvalue(res?.data?.settingvalue);
        }
      } else {
        setSettingvalue("");

        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
    });
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Vat"} isLoading={isLoading} />

      <Layout>
        <SimpleGrid columns={1}>
          <InputComp
            label={"Vat"}
            value={settingvalue}
            onChange={setSettingvalue}
          />
        </SimpleGrid>
      </Layout>
      <ButtonComp
        alignSelf={"end"}
        label="Save"
        onClick={onSave}
        keyname="save"
        disabled={isLoading}
      />
    </Flex>
  );
};

export default Vat;
